import{c as r}from"../../dist/createSprinkles-c150330f.esm.js";var e=r=>r,t=function(){return r(e)(...arguments)};export{t as createSprinkles};
